module.exports = __webpack_public_path__ + "img/icon11.b6f50a60.png";